class FeedChunk {
    constructor(start, end, dateString) {
        this.start = start;
        this.end = end;
        this.dateString = dateString;
    }
}

const WHOLE_DATASET_FEED_CHUNK = new FeedChunk(
    null,
    null,
    "01-17-2024 - 08-29-2024 (Whole Dataset)"
)

const FEED_CHUNKS = [
    new FeedChunk(
        1705467600000, // Epoch millis for 2024-01-17T00:00:00-05:00
        1705553999000, // Epoch millis for 2024-01-17T23:59:59-05:00
        "01-17-2024"
    ),
    new FeedChunk(
        1706677200000, // Epoch millis for 2024-01-31T00:00:00-05:00
        1706763599000, // Epoch millis for 2024-01-31T23:59:59-05:00
        "01-31-2024",
    ),
    new FeedChunk(
        1707886800000, // Epoch millis for 2024-02-14T00:00:00-05:00
        1708059599000, // Epoch millis for 2024-02-15T23:59:59-05:00
        "02-14-2024 - 02-15-2024",
    ),
    new FeedChunk(
        1709787600000, // Epoch millis for 2024-03-07T00:00:00-05:00
        1709873999000, // Epoch millis for 2024-03-07T23:59:59-05:00
        "03-07-2024",
    ),
    new FeedChunk(
        1710907200000, // Epoch millis for 2024-03-20T00:00:00-04:00
        1711166399000, // Epoch millis for 2024-03-22T23:59:59-04:00
        "03-20-2024 - 03-22-2024",
    ),
    new FeedChunk(
        1711425600000, // Epoch millis for 2024-03-26T00:00:00-04:00
        1711684799000, // Epoch millis for 2024-03-28T23:59:59-04:00
        "03-26-2024 - 03-28-2024",
    ),
    new FeedChunk(
        1712116800000, // Epoch millis for 2024-04-03T00:00:00-04:00
        1712375999000, // Epoch millis for 2024-04-05T23:59:59-04:00
        "04-03-2024 - 04-05-2024",
    ),
    new FeedChunk(
        1714449600000, // Epoch millis for 2024-04-30T00:00:00-04:00
        1714622399000, // Epoch millis for 2024-05-01T23:59:59-04:00
        "04-30-2024 - 05-01-2024",
    ),
    new FeedChunk(
        1718078400000, // Epoch millis for 2024-06-11T00:00:00-04:00
        1718251199000, // Epoch millis for 2024-06-12T23:59:59-04:00
        "06-11-2024 - 06-12-2024",
    ),
    new FeedChunk(
        1720929600000, // Epoch millis for 2024-07-14T00:00:00-04:00
        1721447999000, // Epoch millis for 2024-07-19T23:59:59-04:00
        "07-14-2024 - 07-19-2024",
    ),
    new FeedChunk(
        1722312000000, // Epoch millis for 2024-07-30T00:00:00-04:00
        1722571199000, // Epoch millis for 2024-08-01T23:59:59-04:00
        "07-30-2024 - 08-01-2024",
    ),
    new FeedChunk(
        1724040000000, // Epoch millis for 2024-08-19T00:00:00-04:00
        1724471999000, // Epoch millis for 2024-08-23T23:59:59-04:00
        "08-19-2024 - 08-23-2024",
    ),
    new FeedChunk(
        1724731200000, // Epoch millis for 2024-08-27T00:00:00-04:00
        1724990399000, // Epoch millis for 2024-08-29T23:59:59-04:00
        "08-27-2024 - 08-29-2024",
    )
];

export { FEED_CHUNKS, WHOLE_DATASET_FEED_CHUNK }
